import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'

const BuyBundle = () => {

  const [account_number, setAccount_number] = useState('')
  const [phoneError, setPhoneError] = useState(false);
  const [amount, setAmount] = useState('')
  const [client_id, setClient_id] = useState('')
  const [service_type, setService_type] = useState('DATA')
  const [listaccounts, setListaccounts] = useState([])
  const [isloading, setIsloading] = useState(false);
  // const [bundle, setBundle] = useState([])
  const navigate = useNavigate()

  // Fetch user accounts
  const getAccounts = useCallback(async () => {
    try {
      const response = await axios.get('/service_clients/?service_ref_id=5');
      setListaccounts(response.data.items)
    } catch (error) {
      console.log(error);
    }
  }, []);

  // Fetch bundle products
  // const getBundles = useCallback(async () => {
  //   try {
  //     const response = await axios.get('/bundles/');
  //     setBundle(response.data.items)
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }, []);

  useEffect(() => {
    getAccounts()
  }, [getAccounts]);

    
  // Buy data request
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsloading(true);
    try {
      const response = await axios.post('/batch_request/',
        { account_number, amount, client_id, service_type }
      )
      toast.success(response?.data?.message)
      navigate('/app/bundle')
    } catch (error) {
      if (!error?.response) {
        toast.error('No Server Response');
      } else if (error.response?.data?.detail?.toLowerCase().includes("invalid phone")) {
        setPhoneError(true);
        toast.error("Invalid phone number");
      } else if (error.response?.status) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Failed to buy data bundle');
      }
      console.log(error);
    }finally {
      setIsloading(false);
    }
  }

  return (
    <div className='mx-auto p-4'>
      <h4><b>Buy Data</b></h4>
      <section className="bg-white p-4 rounded-lg mt-2">
        <form onSubmit={handleSubmit}>
          <div className="flex items-center flex-wrap">
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='number'><span>Phone Number</span>
                <input
                  type='number'
                  required
                  min="9"
                  placeholder='070000000'
                  className={`px-3 py-2 bg-white border shadow-sm 
                    ${phoneError 
                      ? "border-red-500 focus:border-red-500 focus:ring-red-500" 
                      : "border-slate-300 focus:border-[#165277] focus:ring-[#165277]"
                    }
                    placeholder-slate-400 focus:outline-none block w-full rounded-md sm:text-sm focus:ring-1`
                  }                  value={account_number}
                  onChange={(e) => setAccount_number(e.target.value)}
                />
              </label>
            </div>
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='amount'><span>Bundle Amount</span>
                <select 
                  name="service" id="service"
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                >
                  <option value="">Select..</option>
                  {/* {bundle.map((bundles) => (
                    <option key={bundles.id} value={bundles.value}>{bundles.code}</option>
                  ))} */}
                  <option value="100">100MB@100</option>
                </select>
              </label>
            </div>
          </div>
          <div className="flex items-center flex-wrap">
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='clientid'><span>Account</span>
                <select 
                  name="service" id="service"
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={client_id}
                  onChange={(e) => setClient_id(e.target.value)}
                >
                  <option value="">Select..</option>
                  {listaccounts.map((transaction) => (
                    <option key={transaction.id} value={transaction.client_id}>{transaction.client_id} - {transaction.units?.toLocaleString()} units</option>
                  ))}
                </select>
              </label>
            </div>
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='service'><span>Service Type</span>
                <input
                  type='text'
                  required
                  disabled
                  placeholder='service'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={service_type}
                  onChange={(e) => setService_type(e.target.value)}
                />
              </label>
            </div>
          </div>
          <div className='my-4 text-center'>
            <button disabled={isloading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md hover:bg-[#165277]'>{isloading ? 'Sending...' : 'Buy Data'}</button>
          </div>
        </form>
      </section>
    </div>
  )
}

export default BuyBundle
